import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 32px 0;
  gap: 32px;
  @media (max-width: 1440px) {
    flex-direction: column;
    gap: 32px;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ColumnText = styled(Column)`
  @media (max-width: 800px) {
    gap: 0;
  }
`

const LeftSide = styled.div`
  display: flex;
  gap: 40px;
  max-width: 700px;
  @media (max-width: 800px) {
    gap: 24px;

    flex-direction: column;
  }
`

const RightSide = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 6px;
  width: 50%;

  gap: 24px;
  @media (max-width: 1440px) {
    width: 100%;

    /* padding-left: 40px; */
  }
`

const Title = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 38px;
  font-style: normal;
  font-weight: 900;
  line-height: 64px;
  letter-spacing: 0.5px;
  @media (max-width: 800px) {
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 8px;
  }
`
const SubTitle = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 21px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 2px;
  @media (max-width: 800px) {
    font-size: 18px;
    line-height: 30px;
  }
`

const Image = styled.img`
  border: 4px solid ${props => props.theme.secondary700};
  border-radius: 100%;
  min-width: ${props => `${props.width}px`};
  min-height: ${props => `${props.width}px`};
  max-height: 197px;
`
const TeamImage = styled(Image)`
  max-height: 70px;
  object-fit: cover;
  @media (max-width: 800px) {
    border: 2px solid ${props => props.theme.secondary700};

    max-height: 46px;
    max-width: 46px;
    min-width: 46px;
    min-height: 46px;
  }
`

const ImageHolder = styled.div`
  max-width: 50px;
  overflow: show;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${props => props.$zIndex};
  @media (max-width: 800px) {
    max-width: 25px;
  }
`

const ImageRow = styled.div`
  position: relative;
  display: flex;
  padding-left: 14px;

  @media (max-width: 800px) {
  }
`

const HelpText = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 38px;
  font-style: normal;
  font-weight: 800;
  line-height: 50px;
  text-wrap: nowrap;
  @media (max-width: 800px) {
    font-size: 28px;
    line-height: 40px;
  }
`

const SupLink = styled.a`
  color: #fff;
  font-size: 21px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  cursor: pointer;
  @media (max-width: 800px) {
    font-size: 13.961px;
  }
`

const SpeechBubble = styled.div`
  margin-left: 32px;
  position: relative;
  background: #26383b;
  padding: 16px 24px;
  border-radius: 12px;

  text-align: left;
  width: max-content;
  max-width: max-content;
  height: max-content;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 20px 0 0;
    border-color: transparent #26383b transparent transparent;
  }

  width: 100%;

  @media (max-width: 800px) {
    font-size: 13px !important;
    padding: 11px 13px;
    width: 100%;
  }
`

const tourTypes = {
  US: {
    title: "American Travellers!",
    subtitle:
      "Book with a company whose mission is to help Americans explore the world.",
    image:
      "https://d3owbckoeihl9o.cloudfront.net/images/static-images/indy-tour-page/American.png",
    alt: "We are North American",
  },
  CA: {
    title: "We’re Canadian",
    subtitle:
      "Book with a Canadian company whose mission is to help you travel the world.",
    image:
      "https://d3owbckoeihl9o.cloudfront.net/images/static-images/indy-tour-page/Canadian.png",
    alt: "We are Canadian",
  },
  GB: {
    title: "British Owned",
    subtitle:
      "10Adventures was co-founded by English entrepreneur Lynn Campbell. Our mission is to help you travel the world!",
    image:
      "https://d3owbckoeihl9o.cloudfront.net/images/static-images/indy-tour-page/British.png",
    alt: "We are British",
  },
  adventure: {
    title: "We know Adventure",
    subtitle:
      "10Adventures only does Hiking, Cycling and Adventure Holidays. Its our mission to help you explore the world!",
    image:
      "https://d3owbckoeihl9o.cloudfront.net/images/static-images/indy-tour-page/Pilgrimmage.png",
    alt: "We are Australian",
  },
}

const WeAre = ({ type, setIsQuestionOpen }) => {
  type = type === "UK" ? "GB" : type
  const content = tourTypes[type] || tourTypes.adventure

  return (
    <Wrapper>
      <LeftSide>
        <Image width={197} src={content.image} alt={content.alt} />
        <ColumnText>
          <Title>{content.title}</Title>
          <SubTitle>{content.subtitle}</SubTitle>
        </ColumnText>
      </LeftSide>
      <RightSide>
        <Column>
          <HelpText>We’re here to help!</HelpText>
          <ImageRow>
            {[1, 2, 3, 4].map(z => (
              <ImageHolder key={z} $zIndex={4 - z}>
                <TeamImage
                  width={70}
                  height={70}
                  src={`https://d3owbckoeihl9o.cloudfront.net/images/static-images/indy-tour-page/Support${z}.png`}
                  alt="We're here to help"
                />
              </ImageHolder>
            ))}
            <SpeechBubble onClick={() => setIsQuestionOpen(true)}>
              <SupLink>Ask us a question about this tour</SupLink>
            </SpeechBubble>
          </ImageRow>
        </Column>
      </RightSide>
    </Wrapper>
  )
}

WeAre.propTypes = {
  setIsQuestionOpen: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["CA", "GB", "UK", "US"]),
}

export default WeAre
